<template>
  <div id="intergenerational-family-journey-app-container" :class="'container intergenerational-family-journey-app-container camp' + camp + ' path' + path + ' step' + step + ' introEnd' + introEnd + ' playing' + playing + ' showContent' + showContent">
    
    <header>
      <div class="logo"><img :src="baseurl + 'assets/images/fex-logo.svg'" alt="Family Enterprise Foundation" class="logo" @click="goToIntro()"  /></div>
  
      <h1>
        Intergenerational Succession Journey Map<br />
        <!--audio preload="auto" ref="audiomap" controls @pause="pauseVideo()" @play="playVideo()" @timeupdate="onTimeUpdate"  id="audiomap" :src="baseurl + 'assets/audios/outputv2.mp3'"></audio-->
      </h1>

      <div v-if="getAnswer('intro-questionnaire-question7')" :class=" (menu ? 'open ' : '') + 'menu'">
        <div class="handle" @click=" (menu ? menu = 0 : menu = 1) ">
          <span class="text">MENU</span>
          <span class="line1"></span>
          <span class="line2"></span>
          <span class="line3"></span>
        </div>
        
        <div class="select-path">
          <a @click="goToIntro(); menu = 0;" class="introduction">Introduction</a>
          <a @click="goToIntro(1); introEnd = 1; showQuestionnaire = 1; menu = 0;" class="questionnaire">Introduction Questionnaire</a>
          <a @click="goToCamp(5, 1); menu = 0;" :class="camp == 5 && path == 1 ? 'resources active' : 'resources'">Family Office Resources</a>
          <a @click="goToCamp(6, 1); menu = 0;" :class="camp == 6 && path == 1 ? 'glossary active' : 'glossary'">Resources Glossary</a><!-- @click="goToCamp(6, 1); menu = 0;"-->
          <a href="https://familyenterprise.ca/fea-directory/" target="_blank">Find a Family Enterprise Advisor (FEA)</a>
        </div>
      </div>
    </header>
    
    <div id="background-video">
      <!-- 1080808015 -->
      <VimeoPlayer 
        :class="videoClass"
        ref="player" 
        video-id="1081540833"
        :options="options"
        @ready="vimeoOnReady"
        @cuepoint="vimeoOnCuepoint"
        @timeupdate="handleTimeUpdate"
      ></VimeoPlayer>

      <!--div class="Mainintro">
        <div class="c c1"></div>
        <div class="c c2"></div>
        <div class="c c3"></div>
        <div class="c c4"></div>
      </div-->
      
      <div v-if="introEnd > 0 && showQuestionnaire" id="introEnd" class="overlay">
       
        <div id="intro-questionnaire">
          
          <div class="question" id="intro-questionnaire-question1" v-if="intro_question == 1 || !getAnswer('intro-questionnaire-question1')">
            <h2>Which Generation are you in?</h2>
            <ul :class="intro_answer1">
              <li class="gen1" @click="saveAnswer('intro-questionnaire-question1', 'gen1');">1<sup>st</sup> Generation</li>
              <li class="gen2" @click="saveAnswer('intro-questionnaire-question1', 'gen2');">2<sup>nd</sup> Generation</li>
              <li class="gen3" @click="saveAnswer('intro-questionnaire-question1', 'gen3');">3<sup>rd</sup> Generation</li>
              <li class="gen4" @click="saveAnswer('intro-questionnaire-question1', 'gen4');">4<sup>th</sup> + Generation</li>
            </ul>
          </div>

          <div class="question" id="intro-questionnaire-question2" v-if="intro_question == 2 && getAnswer('intro-questionnaire-question1')">
            <h2>In terms of Transmitting Family Values Between Generations...</h2>
            <ul :class="intro_answer2">
              <li class="values-not-radar" @click="saveAnswer('intro-questionnaire-question2', 'values-not-radar');">Family values are not on our radar</li>
              <li class="values-not-transmitted" @click="saveAnswer('intro-questionnaire-question2', 'values-not-transmitted');">Not transmitted at all</li>
              <li class="values-mentioned-outdated" @click="saveAnswer('intro-questionnaire-question2', 'values-mentioned-outdated');">They are mentioned, but they seem outdated</li>
              <li class="values-talked-about" @click="saveAnswer('intro-questionnaire-question2', 'values-talked-about');">We talk about them at family events</li>
              <li class="values-deeply-engrained" @click="saveAnswer('intro-questionnaire-question2', 'values-deeply-engrained');">They are deeply engrained in everything we do</li>
            </ul>
          </div>

          <div class="question" id="intro-questionnaire-question3" v-if="intro_question == 3 && getAnswer('intro-questionnaire-question2')">
            <h2>Hurdles to a successful intergenerational transfer are....</h2>
            <ul :class="intro_answer3">
              <li class="selling" @click="saveAnswer('intro-questionnaire-question3', 'selling');">We are focussed on selling, not transferring</li>
              <li class="not-interested" @click="saveAnswer('intro-questionnaire-question3', 'not-interested');">Next Generation members are not interested</li>
              <li class="no-letting-go" @click="saveAnswer('intro-questionnaire-question3', 'no-letting-go');">The Senior generation is not willing to let go</li>
              <li class="not-ready" @click="saveAnswer('intro-questionnaire-question3', 'not-ready');">The next generation is not ready</li>
            </ul>
          </div>

          <div class="question" id="intro-questionnaire-question4" v-if="intro_question == 4 && getAnswer('intro-questionnaire-question3')">
            <h2>When it comes to discussing our future transition strategy, our family speaks about it</h2>
            <ul :class="intro_answer4">
              <li class="never" @click="saveAnswer('intro-questionnaire-question4', 'never');">Never</li>
              <li class="rarely" @click="saveAnswer('intro-questionnaire-question4', 'rarely');">Rarely</li>
              <li class="sometimes" @click="saveAnswer('intro-questionnaire-question4', 'sometimes');">Sometimes</li>
              <li class="often" @click="saveAnswer('intro-questionnaire-question4', 'often');">Often</li>
              <li class="always" @click="saveAnswer('intro-questionnaire-question4', 'always');">Always</li>
            </ul>
          </div>

          <div class="question" id="intro-questionnaire-question5" v-if="intro_question == 5 && getAnswer('intro-questionnaire-question4')">
            <h2>What governance structures are active in your family ?</h2>
            
            <ul :class="(intro_answer5 && intro_answer5 != '' ? intro_answer5 : '')">
              <li class="code-of-conduct" @click="saveAnswer5('intro-questionnaire-question5', 'code-of-conduct');">Family Code of Conduct</li>
              <li class="family-meetings" @click="saveAnswer5('intro-questionnaire-question5', 'family-meetings');">Family Meetings</li>
              <li class="family-council" @click="saveAnswer5('intro-questionnaire-question5', 'family-council');">Family Council</li>
              <li class="family-constitution" @click="saveAnswer5('intro-questionnaire-question5', 'family-constitution');">Family Constitution</li>
              <li class="shareholders-agreement" @click="saveAnswer5('intro-questionnaire-question5', 'shareholders-agreement');">Shareholders' Agreement</li>
              <li class="owners-council" @click="saveAnswer5('intro-questionnaire-question5', 'owners-council');">Owners' Council</li>
              <li class="board-directors" @click="saveAnswer5('intro-questionnaire-question5', 'board-directors');">Board of Directors</li>
              <li class="advisory-board" @click="saveAnswer5('intro-questionnaire-question5', 'advisory-board');">Advisory Board</li>
            </ul>
          </div>

          <div class="question" id="intro-questionnaire-question6" v-if="intro_question == 6 && getAnswer('intro-questionnaire-question5')">
            <h2>How prepared is our family for a leadership transition?</h2>
            <ul :class="intro_answer6">
              <li class="very-unprepared" @click="saveAnswer('intro-questionnaire-question6', 'very-unprepared');">Very unprepared</li>
              <li class="unprepared" @click="saveAnswer('intro-questionnaire-question6', 'unprepared');">Unprepared</li>
              <li class="somewhat-prepared" @click="saveAnswer('intro-questionnaire-question6', 'somewhat-prepared');">Somewhat prepared</li>
              <li class="prepared" @click="saveAnswer('intro-questionnaire-question6', 'prepared');">Prepared</li>
              <li class="very-prepared" @click="saveAnswer('intro-questionnaire-question6', 'very-prepared');">Very prepared</li>
            </ul>
          </div>

          <div class="question" id="intro-questionnaire-question7" v-if="intro_question == 7 && getAnswer('intro-questionnaire-question6')">
            <h2>Which circle do you want to explore first?</h2>
            <ul :class="intro_answer7">
              <li class="family" @click="saveAnswer('intro-questionnaire-question7', 'family'); setPath(1,0); ">Family</li>
              <li class="business" @click="saveAnswer('intro-questionnaire-question7', 'business'); setPath(2,0); ">Business</li>
              <li class="ownership" @click="saveAnswer('intro-questionnaire-question7', 'ownership'); setPath(3,0);">Ownership</li>
            </ul>
          </div>

          <!--div class="question" id="intro-questionnaire-question8" v-if="intro_question == 8 && getAnswer('intro-questionnaire-question7')">
            <h2>Which transition issue is most pressing for you?</h2>
            <ul :class="intro_answer8">
              <li class="governance" @click="saveAnswer('intro-questionnaire-question8', 'governance'); setStep(2);">Governance</li>
              <li class="vision-and-values" @click="saveAnswer('intro-questionnaire-question8', 'vision-and-values'); setStep(3);">Vision and Values</li>
              <li class="leadership" @click="saveAnswer('intro-questionnaire-question8', 'leadership'); setStep(4);">Leadership</li>
              <li class="financing-the-transition" @click="saveAnswer('intro-questionnaire-question8', 'financing-the-transition'); setStep(5);">Financing the Transition</li>
              <li class="not-sure" @click="saveAnswer('intro-questionnaire-question8', 'not-sure'); setStep(1);">Not sure</li>
            </ul>
          </div-->

          <ul class="intro-question-nav">
            <li v-for="i in [1,2,3,4,5,6,7]" v-bind:key="i" :class="(
              intro_question == i ? 
              'current' + (getAnswer('intro-questionnaire-question' + i) ? ' done ' : '') : 
              (getAnswer('intro-questionnaire-question' + i) ? ' done ' : '')
            )" @click="setIntroQuestion(i)"><span></span></li>
            
          </ul>
          <!--&& getAnswer('intro-questionnaire-question8')-->
          <a v-if="getAnswer('intro-questionnaire-question1') && getAnswer('intro-questionnaire-question2') && getAnswer('intro-questionnaire-question3') && getAnswer('intro-questionnaire-question4') && getAnswer('intro-questionnaire-question5') && getAnswer('intro-questionnaire-question6') && getAnswer('intro-questionnaire-question7') && showQuestionnaire" @click="launch()" id="intro-start">Start</a>
          
          <a v-if="intro_question > 1" @click="previousIntroQuestion()" id="intro-previous"><span><span class="l"></span><span class="r"></span></span></a>
          <a v-if="intro_question < 7" @click="nextIntroQuestion()" id="intro-next"><span><span class="l"></span><span class="r"></span></span></a>

        </div>
      </div>
      <div v-else-if="introEnd == 0" class="overlay hugePlayButton">
        <div> 
          <button @click="start_playing" v-if="!playing">
            <svg width="100" height="100" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
              <polygon points="30,20 30,80 80,50" fill="black"/>
            </svg>
          </button> 
          <button class="pauseButton" v-if="playing" @click="pauseVideo">
            <svg width="100" height="100" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
              <rect x="30" y="20" width="15" height="60" fill="black"/>
              <rect x="55" y="20" width="15" height="60" fill="black"/>
            </svg>
          </button>
        </div>
      </div>
    </div>
   
    <div v-if="!showQuestionnaire" id="map-content" @click="hideSurvey()">
      <div class="authorize hugePlayButton">
        <div> 
          <button @click="start_playing" v-if="!playing">
            <svg width="100" height="100" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
              <polygon points="30,20 30,80 80,50" fill="black"/>
            </svg>
          </button> 
          <button class="pauseButton" v-if="playing" @click="pauseVideo">
            <svg width="100" height="100" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
              <rect x="30" y="20" width="15" height="60" fill="black"/>
              <rect x="55" y="20" width="15" height="60" fill="black"/>
            </svg>
          </button>
        </div>
      </div>

      <template v-for="thecamp in camps">
        <div v-bind:key="thecamp" :class="'camp' + thecamp">
          <template v-for="thepath in [1,2,3]">
            <div v-bind:key="thepath" :class="'camp' + thecamp + 'path' + thepath">
              <div class="path">
                <div :ref="'camp' + thecamp + 'path' + thepath" :id="'camp' + thecamp + 'path' + thepath" :class="openedTile !== 0 ? 'step-content open' : 'step-content'">
                  <a v-if="openedTile !== 0" class="back-to-list" @click="closeTile()"><span>&lt;</span> Back to the list</a>
                  <a v-if="openedTile === 0" class="close" @click="voidPath()"><span>x</span></a>

                  <p v-if="fromQuestionnaire"><strong>Welcome to Gen {{thecamp}}! If you feel that you may not be in the right spot or you need more of an introduction to the content, we suggest starting in <a class="step1" @click="showTile('1.1.1')">Gen 1</a>.</strong></p>

                  <ul v-if="openedTile === 0" :class="('nav step' + step)">
                    <li><a class="step1" @click="showTile(thecamp + '.' + thepath + '.1')">Setting the Table <span :class="getProgress(1) + 'progress p' + progress1"></span></a></li>
                    <li><a class="step2" @click="showTile(thecamp + '.' + thepath + '.2')">Governance <span :class="getProgress(2) + 'progress p' + progress2"></span></a></li>
                    <li><a class="step3" @click="showTile(thecamp + '.' + thepath + '.3')">Vision & Values <span :class="getProgress(3) + 'progress p' + progress3"></span></a></li>
                    <li><a class="step4" @click="showTile(thecamp + '.' + thepath + '.4')">Leadership <span :class="getProgress(4) + 'progress p' + progress4"></span></a></li>
                    <li v-if="camp == 1"><a class="step5" @click="showTile(thecamp + '.' + thepath + '.5')">Financing <span :class="getProgress(5) + 'progress p' + progress5"></span></a></li>
                    <li v-else><a class="step5" @click="showTile(thecamp + '.' + thepath + '.5')">Assets <span :class="getProgress(5) + 'progress p' + progress5"></span></a></li>
                    <li v-if="camp == 2 && path != 1"><a class="step6" @click="showTile(thecamp + '.' + thepath + '.6')">Financing <span :class="getProgress(6) + 'progress p' + progress6"></span></a></li>
                  </ul>

                  <h1 v-if="(openedTile === 0 && step == 1)">Setting the Table</h1>
                  
                  <h1 v-if="(openedTile === 0 && step == 2)">Clarifying the Goals and Priorities</h1>

                  <h1 v-if="(openedTile === 0 && path == 1 && step == 3)">Reviewing (or Defining) Familiy Strategy</h1>
                  <h1 v-if="(openedTile === 0 && path == 2 && step == 3)">Reviewing Business Strategy</h1>
                  <h1 v-if="(openedTile === 0 && path == 3 && step == 3)">Reviewing Owner's Strategy</h1>

                  <h1 v-if="(openedTile === 0 && step == 4)">Planning the Transition of Responsibilities </h1>

                  <h1 v-if="(openedTile === 0 && path == 1 && step == 5)">Transitioning Family Value</h1>
                  <h1 v-if="(openedTile === 0 && path == 2 && step == 5)">Transitioning Business Value & Control</h1>
                  <h1 v-if="(openedTile === 0 && path == 3 && step == 5)">Transitioning Ownerhsip Value</h1>

                  <h1 v-if="(openedTile === 0 && step == 6)">Financing the Succession</h1>
                  
                  <template v-for="thestep in steps">
                    <ul v-bind:key="thestep" :class="'progress-line list-step' + thestep">
                      
                      <li v-bind:key="item.id" v-for="item in getTDM('camp' + thecamp, thepath, 'step' + thestep)" :class="statusClass(item.id)">
                        <span class="item-number">{{ item.order }}</span>
                        <div v-if="!isOpened(item.id)" class="preview" @click="showTile(item.id)">
                          <div class="thumbnail">
                              <img :src="baseurl + item.image" :alt="item.title">
                          </div>
                          <div class="description">
                              <strong>{{ item.title }}</strong>
                          </div>
                        </div>
                        <div v-if="isOpened(item.id)" class="item-content">
                          <template v-if="item.type == 'component'">
                            <three-circle-model v-if="item.content == 'three-circle-model-1'" model="c1p1s1t1" />
                            <three-circle-model v-if="item.content == 'three-circle-model-2'" model="c1p1s1t2" />
                            <three-circle-model v-if="item.content == 'three-circle-model-3'" model="c1p1s1t3" />
                            <three-circle-model v-if="item.content == 'three-circle-model-4'" model="c1p1s3t3" />
                            <three-circle-model v-if="item.content == 'three-circle-model-5'" model="c1p3s1t5" />
                            
                            <who-is-family v-if="item.content == 'who-is-family'" />

                            <Quiz1 v-if="item.content == 'quiz-1'" />
                            <Quiz2 v-if="item.content == 'quiz-2'" />
                            <Quiz3 v-if="item.content == 'quiz-3'" />

                            <Audio1 v-if="item.content == 'audio-1'" />
                            <Audio2 v-if="item.content == 'audio-2'" />
                          </template>

                          <template v-if="item.type == 'video'">
                            <div class="block" v-html="prepareUrl(item.content.html)"></div>
                            <iframe :src="item.content.video" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen=""></iframe>
                          </template>

                          <template v-if="item.type == 'videos'">
                            <div class="col" v-bind:key="video" v-for="video in item.content">
                              <div v-html="prepareUrl(video.html)"></div>
                              <iframe :src="video.video" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen=""></iframe>
                            </div>
                          </template>

                          <template v-if="item.type == 'play-link'">
                            <div class="block">
                              <h1>{{ item.title }}</h1>
                              <a :href="item.content.link" target="_blank" class="play-link">
                                <span>{{ item.content.cta }}</span>
                                <img :src="baseurl + item.content.image" style="max-width: 80%; height: auto; margin-left: auto; margin-right: auto; display: block;">
                              </a>
                            </div>
                          </template>

                          <template v-if="item.type == 'pdf'">
                            <div class="block" v-html="prepareUrl(item.content.html)"></div>
                            <iframe :src="baseurl + item.content.pdf" class="pdf"></iframe>
                          </template>

                          <template v-if="item.type == 'iframe'">
                            <div class="block" v-html="prepareUrl(item.content.html)"></div>
                            <iframe :src="prepareUrl(item.content.iframe)" class="tut"></iframe>
                          </template>

                          <template v-if="item.type == 'html' || item.type == 'podcast'">
                            <div class="block" v-html="prepareUrl(item.content)"></div>
                          </template>

                          <template v-if="item.type == 'questions'">
                            <div v-if="item.content.length > 0" class="questions">
                              <button class="btn print" onclick="window.print()">Print</button>
                              <ul>
                                <li v-for="(q, i) in item.content" v-bind:key="q">
                                  <strong>{{ q }}</strong><br />
                                  <textarea v-model="questions[item.id + '-q-' + i]" @change="saveAnswer(item.id + '-q-' + i, questions[item.id + '-q-' + i])"></textarea>
                                </li>
                              </ul>
                            </div>
                          </template>

                          
                          <div v-if="item.attachments.length > 0" class="additional-resources">
                            <h3>Additional Resources</h3>
                            <ul>
                                <li v-for="attachment in item.attachments" v-bind:key="attachment.url" :class="attachment.type">
                                  <a :href="prepareUrl(attachment.url)" target="_blank">{{ attachment.label }}</a>
                                </li>
                            </ul>
                          </div>

                          <div :class="'nav nav' + thepath">
                              <a class="previous" v-if="item.previous != ''" @click="showTile(item.previous);">Previous</a>
                              <a class="next" v-if="item.next != ''" @click="showTile(item.next);">Next</a>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </template>
                </div>
              </div>
            </div>
          </template>
        </div>
      </template>
    </div>


    <div v-if="isActiveTab('camp5') && camp5code == '1234!'" class="camp5">
      <div class="camp5map">
        <img :src="baseurl + 'assets/images/family-resources-background.jpg'" style="width: 100%; height: auto;" />
        
        <div class="shack shack1">
          <a href="https://www.familyoffice.com/" target="_blank">Family Office Exchange(FOX) <small>FO Membership Organization</small></a>	
        </div>

        <div class="shack shack2">
          <a href="https://www.familyofficeassociation.com/" target="_blank">Family Office Association <small>FO Membership Organization</small></a>	
        </div>

        <div class="shack shack3">
          <a href="https://www.northwoodfamilyoffice.com/" target="_blank">Northwood Family Office <small>Multi-Family Office - Canada</small></a>	
        </div>

        <div class="shack shack4">
          <a href="https://primequadrant.com/" target="_blank">Prime Quadrant <small>Multi-Family Office - Canada</small></a>	
        </div>

        <div class="shack shack5">
          <a href="https://canadianfamilyoffices.com/" target="_blank">Canadian Family Offices <small>FO Resources</small></a>	
        </div>

      </div>
      <p>If you would like to explore additional Family Office resources, we suggest starting with these. As always, we are here to help you or answer any questions you may have at info@familyenterprise.ca</p>
    </div>
    <div v-else-if="isActiveTab('camp5')">
      <div class="camp5map">
        <img :src="baseurl + 'assets/images/family-resources-background.jpg'" style="width: 100%; height: auto;" />
      </div>
      <p>This section is private. Please provide the access code: <input v-model="camp5code" type="text" value="" ></p>
      
    </div>

    
    <div v-if="isActiveTab('camp6')" class="camp6">
      <div class="col mapnav">
        <img :src="baseurl + 'assets/images/inside-cabine.jpeg'" />

        <div class="c1"><a @click="glossarycamp = 1">Gen 1</a></div>
        <div class="c2"><a @click="glossarycamp = 2">Gen 2</a></div>
        <div class="c3"><a @click="glossarycamp = 3">Gen 3</a></div>
        <div class="c4"><a @click="glossarycamp = 4">Gen 4</a></div>

      </div>
      <div class="col filters">
        
        <template>
          <div class="filters">
            <label>Select a generation<br />
              <select v-model="glossarycamp">
                <option value=""></option>
                <option value="1">Gen 1</option>
                <option value="2">Gen 2</option>
                <option value="3">Gen 3</option>
                <option value="4">Gen 4</option>
              </select>
            </label>

            <label>Select a circle<br />
              <select v-model="glossarypath">
                <option value=""></option>
                <option value="1">Family</option>
                <option value="2">Business</option>
                <option value="3">Ownership</option>
              </select>
            </label>

            <label>Select a content type<br />
              <select v-model="glossarytype">
                <option value=""></option>
                <option value="html">Article</option>
                <option value="externa">External content</option>
                <option value="component">Interactive model</option>
                <option value="pdf">PDF</option>
                <option value="podcast">Podcast</option>
                <option value="video">Video</option>
              </select>
            </label>

          </div>
        
          <!-- <h1 v-if="(openedTile === 0 && step == 1)">Setting the Table</h1>
          
          <h1 v-if="(openedTile === 0 && step == 2)">Clarifying the Goals and Priorities</h1>

          <h1 v-if="(openedTile === 0 && path == 1 && step == 3)">Reviewing (or Defining) Familiy Strategy</h1>
          <h1 v-if="(openedTile === 0 && path == 2 && step == 3)">Reviewing Business Strategy</h1>
          <h1 v-if="(openedTile === 0 && path == 3 && step == 3)">Reviewing Owner's Strategy</h1>

          <h1 v-if="(openedTile === 0 && step == 4)">Planning the Transition of Responsibilities </h1>

          <h1 v-if="(openedTile === 0 && path == 1 && step == 5)">Transitioning Family Value</h1>
          <h1 v-if="(openedTile === 0 && path == 2 && step == 5)">Transitioning Business Value & Control</h1>
          <h1 v-if="(openedTile === 0 && path == 3 && step == 5)">Transitioning Ownerhsip Value</h1>

          <h1 v-if="(openedTile === 0 && step == 6)">Financing the Succession</h1>
           -->
          
          <div class="step-content">

            <ul v-if="glossarycamp" class="progress-line">
              <template v-for="items in getTDMByCamp('camp' + glossarycamp, glossarypath)" >
                <template v-if="items.step1">
                  <template v-for="s in steps">
                    <template v-if="items['step' + s]">

                      <template v-for="i in items['step' + s]">
                        <li v-bind:key="i.id" v-if="glossarytype == '' || i.type.match(glossarytype)" :class="statusClass(i.id)">
                          <span class="item-number">{{ typeLabel(i.type) }}</span>
                          <div class="preview" @click="showTile(i.id)">
                            <div class="thumbnail">
                                <img :src="baseurl + i.image" :alt="i.title">
                            </div>
                            <div class="description">
                                <strong>{{ i.title }}</strong>
                            </div>
                          </div>
                        </li>
                      </template>

                    </template>
                  </template>
                </template>

                <template v-else>
                  
                  <template v-for="i in items">
                    <li v-bind:key="i.id" v-if="glossarytype == '' || i.type.match(glossarytype)" :class="statusClass(i.id)">
                      <span class="item-number">{{ typeLabel(i.type) }}</span>
                      <div class="preview" @click="showTile(i.id)">
                        <div class="thumbnail">
                            <img :src="baseurl + i.image" :alt="i.title">
                        </div>
                        <div class="description">
                            <strong>{{ i.title }}</strong>
                        </div>
                      </div>
                    </li>
                  </template>
                </template>
              </template>
            </ul>
          
            <div v-else><p>Please select a generation to start filtering the contents.</p></div>
          </div>

        </template>
               

      </div>
    </div>
    
    <a v-if="isActiveTab('intro') && playing" @click="setIntroNav()" id="skip">Start</a>
    
    <a class="skip11" v-if="isActiveTab('camp1') && (path == 1 || path == 0) && playing" @click="setCook('camp11End', 1); showTile('1.1.1.1')" id="skip">Skip</a>
    <a class="skip12" v-if="isActiveTab('camp1') && path == 2 && playing" @click="setCook('camp12End', 1); showTile('1.2.1.1')" id="skip">Skip</a>
    <a class="skip13" v-if="isActiveTab('camp1') && path == 3 && playing" @click="setCook('camp13End', 1); showTile('1.3.1.1')" id="skip">Skip</a>
    <a class="skip21" v-if="isActiveTab('camp2') && (path == 1 || path == 0) && playing" @click="setCook('camp21End', 1); showTile('2.1.1.1')" id="skip">Skip</a>
    <a class="skip22" v-if="isActiveTab('camp2') && path == 2 && playing" @click="setCook('camp22End', 1); showTile('2.2.1.1')" id="skip">Skip</a>
    <a class="skip23" v-if="isActiveTab('camp2') && path == 3 && playing" @click="setCook('camp23End', 1); showTile('2.3.1.1')" id="skip">Skip</a>
    <a class="skip31" v-if="isActiveTab('camp3') && (path == 1 || path == 0) && playing" @click="setCook('camp31End', 1); showTile('3.1.1.1')" id="skip">Skip</a>
    <a class="skip32" v-if="isActiveTab('camp3') && path == 2 && playing" @click="setCook('camp32End', 1); showTile('3.2.1.1')" id="skip">Skip</a>
    <a class="skip33" v-if="isActiveTab('camp3') && path == 3 && playing" @click="setCook('camp33End', 1); showTile('3.3.1.1')" id="skip">Skip</a>
    <a class="skip41" v-if="isActiveTab('camp4') && (path == 1 || path == 0) && playing" @click="setCook('camp41End', 1); showTile('4.1.1.1')" id="skip">Skip</a>
    <a class="skip42" v-if="isActiveTab('camp4') && path == 2 && playing" @click="setCook('camp42End', 1); showTile('4.2.1.1')" id="skip">Skip</a>
    <a class="skip43" v-if="isActiveTab('camp4') && path == 3 && playing" @click="setCook('camp43End', 1); showTile('4.3.1.1')" id="skip">Skip</a>
    
    <footer v-if="getAnswer('intro-questionnaire-question7')" class="select-path">
      <div :class="'camp camp1' + (camp == 1 ? ' active ' : (camp > 0 && camp < 5 ? ' not-active ' : ''))">
        <h3>Gen 1</h3>
        <a @click="showTile('1.1.1'); menu = 0;" :class="camp == 1 && path == 1 ? 'family active' : 'family'">Family</a>
        <a @click="showTile('1.2.1'); menu = 0;" :class="camp == 1 && path == 2 ? 'business active' : 'business'">Business</a>
        <a @click="showTile('1.3.1'); menu = 0;" :class="camp == 1 && path == 3 ? 'ownership active' : 'ownership'">Ownership</a>
      </div>
      <div :class="'camp camp2' + (camp == 2 ? ' active ' : (camp > 0 && camp < 5 ? ' not-active ' : ''))">
        <h3>Gen 2</h3>
        <a @click="showTile('2.1.1'); menu = 0;" :class="camp == 2 && path == 1 ? 'family active' : 'family'">Family</a>
        <a @click="showTile('2.2.1'); menu = 0;" :class="camp == 2 && path == 2 ? 'business active' : 'business'">Business</a>
        <a @click="showTile('2.3.1'); menu = 0;" :class="camp == 2 && path == 3 ? 'ownership active' : 'ownership'">Ownership</a>
      </div>
      <div :class="'camp camp3' + (camp == 3 ? ' active ' : (camp > 0 && camp < 5 ? ' not-active ' : ''))">
        <h3>Gen 3</h3>
        <a @click="showTile('3.1.1'); menu = 0;" :class="camp == 3 && path == 1 ? 'family active' : 'family'">Family</a>
        <a @click="showTile('3.2.1'); menu = 0;" :class="camp == 3 && path == 2 ? 'business active' : 'business'">Business</a>
        <a @click="showTile('3.3.1'); menu = 0;" :class="camp == 3 && path == 3 ? 'ownership active' : 'ownership'">Ownership</a>
      </div>
      <div :class="'camp camp4' + (camp == 4 ? ' active ' : (camp > 0 && camp < 5 ? ' not-active ' : ''))">
        <h3>Gen 4</h3>
        <a @click="showTile('4.1.1'); menu = 0;" :class="camp == 4 && path == 1 ? 'family active' : 'family'">Family</a>
        <a @click="showTile('4.2.1'); menu = 0;" :class="camp == 4 && path == 2 ? 'business active' : 'business'">Business</a>
        <a @click="showTile('4.3.1'); menu = 0;" :class="camp == 4 && path == 3 ? 'ownership active' : 'ownership'">Ownership</a>
      </div>
    </footer>
    <footer :class="credits ? 'open' : ''">
      <div class="credits" @click="toggleCredit(); openForm">
        <a id="credits">Credits</a>
        <div v-if="credits">
          <h2>Thank You!</h2>
          <p>Family Enterprise Foundation and Family Enterprise Canada would like to thank the following contributors to the Intergenerational Succession Journey Map project. Without their input, guidance, patience and expertise, this project would not have been possible.</p>
          <ul>
            <li>Margaret-Jean Mannix</li>
            <li>Patricia Saputo</li>
            <li>Ambreen Bhaloo</li>
            <li>Wendy Sage-Hayward</li>
            <li>Steve Beauschene</li>
            <li>Olivier de Richoufftz</li>
            <li>Francois Viens</li>
            <li>Thomas Clark</li>
          </ul>
          <p>We would also like to thank the countless families and individuals who have dedicated their time for an interview, thought leadership, or other content contribution over the past 20 years. You have played a critical role in the development of family learning content in Canada.</p>

          <p>As we always strive to improve our educational content, we would also appreciate a moment of your time to provide some feedback on your Intergenerational Succession Journey Map experience.</p>

          <a @click="showSurvey()" id="start-survey">Start the survey</a>

          
        </div>
      </div>

      <div class="copy">© Family Enterprise Foundation. All rights reserved. </div>
    </footer>
  </div>
</template>

<script>
import threeCircleModel from "@/components/three-circle-model.vue";
import whoIsFamily from "@/components/who-is-family.vue";
import Quiz1 from "@/components/Quiz1.vue";
import Quiz2 from "@/components/Quiz2.vue";
import Quiz3 from "@/components/Quiz3.vue";
import Audio1 from "@/components/Audio1.vue";
import Audio2 from "@/components/Audio2.vue";
import VimeoPlayer from "@/components/VimeoPlayer.vue";



function setCookie(name, value, minutes) {
  var expires;
  if (minutes) {
    var date = new Date();
    date.setTime(date.getTime() + (minutes * 60 * 1000));
    expires = "; expires=" + date.toGMTString();
  } else {
    expires = "";
  }
  document.cookie = name + "=" + value + expires + "; path=/";
}

// Read cookie
function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1, c.length);
    }
    if (c.indexOf(nameEQ) === 0) {
      return c.substring(nameEQ.length, c.length);
    }
  }
  return null;
}

export default{
  name: "intergenerational-app",
  components: {
    threeCircleModel,
    whoIsFamily,
    Quiz1,
    Quiz2,
    Quiz3,
    Audio1,
    Audio2,
    VimeoPlayer
  },
  data() {
    return {
      playerReady: 0,
      activeTab: (getCookie('activeTab') ? getCookie('activeTab') : "intro"),
      introEnd: (getCookie('introEnd') ? parseInt(getCookie('introEnd')) : 0),
      openedTile: 0,
      showContent: 0,
      completedTiles: (getCookie("completedTiles") ? JSON.parse(getCookie("completedTiles")) : []),
      currentSlide: getCookie('currentSlide'),
      credits: 0,
      playing: 0,
      points: 0,
      camp5code: '',
      fromQuestionnaire: 0,
      options: {
        autoplay: false,
        loop: false,
        background: false,
        muted: false
      },
      questions: {
        "3.1.1.4-q-0": getCookie('3.1.1.4-q-0'),
        "3.1.1.4-q-1": getCookie('3.1.1.4-q-1'),
        "3.1.1.4-q-2": getCookie('3.1.1.4-q-2'),
        "3.1.1.4-q-3": getCookie('3.1.1.4-q-3'),
        "3.1.2.4-q-0": getCookie('3.1.2.4-q-0'),
        "3.1.2.4-q-1": getCookie('3.1.2.4-q-1'),
        "3.1.2.4-q-2": getCookie('3.1.2.4-q-2'),
        "3.1.3.5-q-0": getCookie('3.1.3.5-q-0'),
        "3.1.3.5-q-1": getCookie('3.1.3.5-q-1'),
        "3.1.4.4-q-0": getCookie('3.1.4.4-q-0'),
        "3.1.5.4-q-0": getCookie('3.1.5.4-q-0'),
        "3.1.5.4-q-1": getCookie('3.1.5.4-q-1'),
        "3.2.1.4-q-0": getCookie('3.2.1.4-q-0'),
        "3.2.1.4-q-1": getCookie('3.2.1.4-q-1'),
        "3.2.2.4-q-0": getCookie('3.2.2.4-q-0'),
        "3.2.2.4-q-1": getCookie('3.2.2.4-q-1'),
        "3.2.3.4-q-0": getCookie('3.2.3.4-q-0'),
        "3.2.3.4-q-1": getCookie('3.2.3.4-q-1'),
        "3.2.4.4-q-0": getCookie('3.2.4.4-q-0'),
        "3.2.4.4-q-1": getCookie('3.2.4.4-q-1'),
        "3.2.4.4-q-2": getCookie('3.2.4.4-q-2'),
        "3.2.5.4-q-0": getCookie('3.2.5.4-q-0'),
        "3.2.5.4-q-1": getCookie('3.2.5.4-q-1'),
        "3.2.5.4-q-2": getCookie('3.2.5.4-q-2'),
        "3.3.1.4-q-0": getCookie('3.3.1.4-q-0'),
        "3.3.1.4-q-1": getCookie('3.3.1.4-q-1'),
        "3.3.2.4-q-0": getCookie('3.3.2.4-q-0'),
        "3.3.2.4-q-1": getCookie('3.3.2.4-q-1'),
        "3.3.3.4-q-0": getCookie('3.3.3.4-q-0'),
        "3.3.3.4-q-1": getCookie('3.3.3.4-q-1'),
        "3.3.4.4-q-0": getCookie('3.3.4.4-q-0'),
        "3.3.4.4-q-1": getCookie('3.3.4.4-q-1'),
        "3.3.5.4-q-0": getCookie('3.3.5.4-q-0'),
        "3.3.5.4-q-1": getCookie('3.3.5.4-q-1'),
        "4.1.1.4-q-0": getCookie('4.1.1.4-q-0'),
        "4.1.1.4-q-1": getCookie('4.1.1.4-q-1'),
        "4.1.2.4-q-0": getCookie('4.1.2.4-q-0'),
        "4.1.2.4-q-1": getCookie('4.1.2.4-q-1'),
        "4.1.3.4-q-0": getCookie('4.1.3.4-q-0'),
        "4.1.3.4-q-1": getCookie('4.1.3.4-q-1'),
        "4.1.3.4-q-2": getCookie('4.1.3.4-q-2'),
        "4.1.4.4-q-0": getCookie('4.1.4.4-q-0'),
        "4.1.4.4-q-1": getCookie('4.1.4.4-q-1'),
        "4.1.5.4-q-0": getCookie('4.1.5.4-q-0'),
        "4.1.5.4-q-1": getCookie('4.1.5.4-q-1'),
        "4.1.5.4-q-2": getCookie('4.1.5.4-q-2'),
        "4.2.1.4-q-0": getCookie('4.2.1.4-q-0'),
        "4.2.1.4-q-1": getCookie('4.2.1.4-q-1'),
        "4.2.1.4-q-2": getCookie('4.2.1.4-q-2'),
        "4.2.2.4-q-0": getCookie('4.2.2.4-q-0'),
        "4.2.2.4-q-1": getCookie('4.2.2.4-q-1'),
        "4.2.3.4-q-0": getCookie('4.2.3.4-q-0'),
        "4.2.3.4-q-1": getCookie('4.2.3.4-q-1'),
        "4.2.4.4-q-0": getCookie('4.2.4.4-q-0'),
        "4.2.4.4-q-1": getCookie('4.2.4.4-q-1'),
        "4.2.5.4-q-0": getCookie('4.2.5.4-q-0'),
        "4.2.5.4-q-1": getCookie('4.2.5.4-q-1'),
        "4.3.1.4-q-0": getCookie('4.3.1.4-q-0'),
        "4.3.1.4-q-1": getCookie('4.3.1.4-q-1'),
        "4.3.1.4-q-2": getCookie('4.3.1.4-q-2'),
        "4.3.2.4-q-0": getCookie('4.3.2.4-q-0'),
        "4.3.2.4-q-1": getCookie('4.3.2.4-q-1'),
        "4.3.3.4-q-0": getCookie('4.3.3.4-q-0'),
        "4.3.3.4-q-1": getCookie('4.3.3.4-q-1'),
        "4.3.4.4-q-0": getCookie('4.3.4.4-q-0'),
        "4.3.4.4-q-1": getCookie('4.3.4.4-q-1'),
        "4.3.5.4-q-0": getCookie('4.3.5.4-q-0'),
        "4.3.5.4-q-1": getCookie('4.3.5.4-q-1')
      },
      authorizedPlay: 0,
      camp: (getCookie('camp') ? parseInt(getCookie('camp')) : 1),
      questionCamp: (getCookie('questionCamp') ? parseInt(getCookie('questionCamp')) : 1),
      path: (getCookie('path') ? parseInt(getCookie('path')) : 0), //1 - Family, 2 - Business, 3 - Ownership
      step: (getCookie('step') ? parseInt(getCookie('step')) : 0),
      tile: (getCookie('tile') ? parseInt(getCookie('tile')) : 0),
      intro_question: 1,
      showQuestionnaire: (getCookie('show-questionnaire') ? parseInt(getCookie('show-questionnaire')) : 1),
      intro_answer1: getCookie('intro-questionnaire-question1'),
      intro_answer2: getCookie('intro-questionnaire-question2'),
      intro_answer3: getCookie('intro-questionnaire-question3'),
      intro_answer4: getCookie('intro-questionnaire-question4'),
      intro_answer5: getCookie('intro-questionnaire-question5'),
      intro_answer6: getCookie('intro-questionnaire-question6'),
      intro_answer7: getCookie('intro-questionnaire-question7'),
      intro_answer8: getCookie('intro-questionnaire-question8'),
      camp11End: getCookie('camp11End'),
      camp12End: getCookie('camp12End'),
      camp13End: getCookie('camp13End'),
      camp21End: getCookie('camp21End'),
      camp22End: getCookie('camp22End'),
      camp23End: getCookie('camp23End'),
      camp31End: getCookie('camp31End'),
      camp32End: getCookie('camp32End'),
      camp33End: getCookie('camp33End'),
      camp41End: getCookie('camp41End'),
      camp42End: getCookie('camp42End'),
      camp43End: getCookie('camp43End'),
      menu: 0,
      glossarycamp: '',
      glossarypath: '',
      glossarytype: '',
      progress1: 0,
      progress2: 0,
      progress3: 0,
      progress4: 0,
      progress5: 0,
      progress6: 0
    }
  },

  beforeDestroy() {
    if (this.$refs.player && this.$refs.player.getPlayer) {
      this.$refs.player.getPlayer().destroy().catch(() => {});
    }
  },

  mounted() {

    if (this.$refs.audiomap && this.$refs.player.player) {
      this.$refs.player.player.pause();
    
      if (getCookie('camp') && getCookie('path')) {
        switch (getCookie('camp') + '-' + getCookie('path')) {
          case '1-1':
              this.$refs.player.player.setCurrentTime(26); break;
          case '1-2':
              this.$refs.player.player.setCurrentTime(89); break;
          case '1-3':
              this.$refs.player.player.setCurrentTime(164); break;
          case '2-1':
              this.$refs.player.player.setCurrentTime(250); break;
          case '2-2':
              this.$refs.player.player.setCurrentTime(357); break;
          case '2-3':
              this.$refs.player.player.setCurrentTime(441); break;
          case '3-1':
              this.$refs.player.player.setCurrentTime(532); break;
          case '3-2':
            this.$refs.player.player.setCurrentTime(673); break;
          case '3-3':
              this.$refs.player.player.setCurrentTime(731); break;
          case '4-1':
              this.$refs.player.player.setCurrentTime(792); break;
          case '4-2':
              this.$refs.player.player.setCurrentTime(911); break;
          case '4-3':
              this.$refs.player.player.setCurrentTime(956); break;
        }

        if (getCookie('currentSlide')) {
          this.showTile(getCookie('currentSlide'));
        }
      } else if (getCookie('introEnd') && getCookie('intro-questionnaire-question1')) {
        this.setIntroNav();
      } else {
        this.goToIntro();
      }


      let answer5 = getCookie('intro-questionnaire-question5');
      if (!answer5) { answer5 = "[]"; }
      answer5 = JSON.parse(answer5);
      let answer5_str = '';
      for (let i = 0; i < answer5.length; i++) {
        answer5_str = answer5_str + ' ' + answer5[i];
      }
      this.intro_answer5 = answer5_str;
    }

  },
  computed: {

    videoClass() {
      return (this.camp != 5 && this.camp != 6 ? 'show': 'hide');
      //return (!this.isActiveTab('intro') && !this.showQuestionnaire && this.camp != 5 && this.camp != 6 ? 'show': 'hide');
    },

    thestep() {
      return this.step;
    },

    camps() {
      return [1,2,3,4];
    },

    steps() {
      if (this.camp == 2 && this.path != 1) {
        return [1,2,3,4,5,6];
      }
      return [1,2,3,4,5];
    },

    intro_answer5_class() {
      let answer5 = getCookie('intro-questionnaire-question5');
      if (!answer5) { answer5 = "[]"; }
      answer5 = JSON.parse(answer5);

      let answer5_str = '';
      for (let i = 0; i < answer5.length; i++) {
        answer5_str = answer5_str + ' ' + answer5[i];
      }

      return answer5_str;
    },
  },
  methods: {

    setCook(key, val) {
      setCookie(key, val);
    },

    typeLabel(t) {
      switch (t) {
        case 'video':
        case 'videos': 
          return 'Video';
        case 'component':
          return 'Interactive Model';
        case 'play-link':
          return 'External Content';
        case 'html':
          return 'Article';
        case 'podcast':
          return 'Podcast';
        case 'pdf':
          return 'PDF';

      }

      return t;

    },

    pauseVideo() {
      this.$refs.player.player.pause();
      this.playing = 0;
    },

    playVideo() {
      //if (this.$refs.audiomap.currentTime > 26) {
      this.$refs.player.player.play();
      this.playing = 1;
      //} 
    },

    start_playing() {
      // if (this.camp && this.path && document.getElementById('camp' + this.camp + 'path' + this.path)) { 
      //   document.getElementById('camp'+ this.camp + 'path'+ this.path).style.right = '-800px'; 
      // }

      if (this.camp && this.path && this.step) {
        this.showTile(this.camp + '.' + this.path + '.' + this.step);
      } else {
        this.showContent = 0;
        //document.getElementById('audiomap').play(); 

        //if (this.$refs.audiomap.currentTime > 26) {
          this.$refs.player.player.play();
          this.playing = 1;
        //} 
      }
      
      this.showQuestionnaire = 0;
      this.authorizedPlay = 1;
    },

    prepareUrl(url) {
      return url.replaceAll("{baseurl}", this.baseurl);
    },

    statusClass(t) {
        let c = '';
        
        if (this.isCompleted(t)) {
            c = c + ' done ';
        }
        
        if (this.activeTile(t)) {
            c = c + ' active ';
        }

        return c;
    }, 

    getProgress(s) {
      let total = 0;
      let self = this;

      let toc = this.getTDMSize('camp' + this.camp, this.path);
      let s_index = 'step' + s;

      if (toc && toc[s_index]) {
        let size = toc[s_index].length;
        let point = Math.ceil(100/size);
        
        toc[s_index].forEach( (p) => {
          if (self.completedTiles.includes(p.id)) { 
            total += point; 
          } 
        });
        if (total > 100) { total = 100; }

        switch (s) {
          case 1: this.progress1 = total; break;
          case 2: this.progress2 = total; break;
          case 3: this.progress3 = total; break;
          case 4: this.progress4 = total; break;
          case 5: this.progress5 = total; break;
          case 6: this.progress6 = total; break;
        }
      }

      return '';
    },

    goto(s) {
        this.step = s;
    },

    activeTile(t) {
      if (this.tile == t) {
          return true;
      }
      return false;
    },


    showTile(t) {       
      let self = this;
      let parts = t.split(".");
      this.camp = parts[0];

      this.fromQuestionnaire = 0;

      setCookie('currentSlide', t);
      setCookie('camp', this.camp);

      this.path = parts[1];
      this.step = parts[2];

      if (this.openedTile) {
        this.closeTile()
      }

      let playit = 0;
      if (parts.length == 3) {
        this.openedTile = 0;
        this.tile = 0;
        this.activeTab = 'camp' + this.camp;
        
        
        // setTimeout( () => {
        //   if (document.getElementById('camp' + self.camp + 'path' + self.path)) {
        //     document.getElementById('camp' + self.camp + 'path' + self.path).parentNode.classList.add("animate");
        //   }
        // }, 500);
        
        if (this.step == 1) {
          this.showContent = 0;
          playit = 1;
        } else {
          this.showContent = 1;
          playit = 0;
        }
          

      } else {
        this.introEnd = 1;
        this.authorizedPlay = 1;
        this.tile = t;
        this.openedTile = t;
        //this.$refs.audiomap.pause();
        this.$refs.player.player.pause();

        // if (document.getElementById('camp' + self.camp + 'path' + self.path)) {
        //   document.getElementById('camp' + self.camp + 'path' + self.path).parentNode.classList.add("animate");
        // }
        this.showContent = 1;

      }

      switch(this.camp + '-' + this.path) {
        case '1-1':
          //this.$refs.audiomap.currentTime = 25;
          this.$refs.player.player.setCurrentTime(26);
          if (!getCookie('camp11End')) { 
            setCookie('camp11End', 1); playit = 1; 
          } else {
            this.showContent = 1; playit = 0;
          }
          break;
        case '1-2':
          //this.$refs.audiomap.currentTime = 88;
          this.$refs.player.player.setCurrentTime(90);
          if (!getCookie('camp12End')) { 
            setCookie('camp12End', 1); playit = 1; 
          } else {
            this.showContent = 1; playit = 0;
          }
          break;

        case '1-3':
          //this.$refs.audiomap.currentTime = 162;
          this.$refs.player.player.setCurrentTime(165);
          if (!getCookie('camp13End')) { 
            setCookie('camp13End', 1); playit = 1; 
          } else {
            this.showContent = 1; playit = 0;
          } 
          break;

        case '2-1':
          //this.$refs.audiomap.currentTime = 250;
          this.$refs.player.player.setCurrentTime(251);
          if (!getCookie('camp21End')) { 
            setCookie('camp21End', 1); playit = 1; 
          } else {
            this.showContent = 1; playit = 0;
          } 
          break; 
         
        case '2-2':
          //this.$refs.audiomap.currentTime = 357;
          this.$refs.player.player.setCurrentTime(358);
          if (!getCookie('camp22End')) { 
            setCookie('camp22End', 1); playit = 1; 
          } else {
            this.showContent = 1; playit = 0;
          }
          break;

        case '2-3':
          //this.$refs.audiomap.currentTime = 441;
          this.$refs.player.player.setCurrentTime(442);
          if (!getCookie('camp23End')) { 
            setCookie('camp23End', 1); playit = 1; 
          } else {
            this.showContent = 1; playit = 0;
          }
          break;

        case '3-1':
          //this.$refs.audiomap.currentTime = 531;
          this.$refs.player.player.setCurrentTime(533); //intro camp 3
          //this.$refs.player.player.setCurrentTime(573);
          if (!getCookie('camp31End')) { 
            setCookie('camp31End', 1); playit = 1; 
          } else {
            this.showContent = 1; playit = 0;
          }
          break;

        case '3-2':
          //this.$refs.audiomap.currentTime = 673;
          this.$refs.player.player.setCurrentTime(674);
          if (!getCookie('camp32End')) { 
            setCookie('camp32End', 1); playit = 1; 
          } else {
            this.showContent = 1; playit = 0;
          }
          break;

        case '3-3':
          //this.$refs.audiomap.currentTime = 730;
          this.$refs.player.player.setCurrentTime(732);
          if (!getCookie('camp33End')) { 
            setCookie('camp33End', 1); playit = 1; 
          } else {
            this.showContent = 1; playit = 0;
          }
          break;

        case '4-1':
          //this.$refs.audiomap.currentTime = 791;
          this.$refs.player.player.setCurrentTime(793); 
          if (!getCookie('camp41End')) { 
            setCookie('camp41End', 1); playit = 1; 
          } else {
            this.showContent = 1; playit = 0;
          }
          break;

        case '4-2':
          //this.$refs.audiomap.currentTime = 910;
          this.$refs.player.player.setCurrentTime(912);
          if (!getCookie('camp42End')) { 
            setCookie('camp42End', 1); playit = 1; 
          } else {
            this.showContent = 1; playit = 0;
          }
          break;

        case '4-3':
          //this.$refs.audiomap.currentTime = 956;
          this.$refs.player.player.setCurrentTime(957);
          if (!getCookie('camp43End')) { 
            setCookie('camp43End', 1); playit = 1; 
          } else {
            this.showContent = 1; playit = 0;
          }
          break;
      }

      if (parts.length == 4) {
        playit = 0;
        this.showContent = 1;
      }

      if (playit) {
        this.showContent = 0;
        //this.$refs.audiomap.play();
        this.$refs.player.player.play();
        this.playing = 1;
      } else {
        this.showContent = 1;
        //this.$refs.audiomap.pause();
        this.$refs.player.player.pause();
        this.playing = 0;
      }

      if (this.$refs['camp' + this.camp + 'path' + this.path] && this.$refs['camp' + this.camp + 'path' + this.path][0]) {
        this.$refs['camp' + this.camp + 'path' + this.path][0].scrollTop = 0;
      }
    },

    closeTile() {
      this.completed(this.openedTile);
      this.openedTile = 0;
      this.tile = 0;
    },

    isOpened(t) {
      if (this.openedTile == t) {
        return true;
      }
      return false;
    },

    completed(t) {

      if (!this.completedTiles.includes(t)) {
        this.completedTiles.push(t);
      }

      setCookie("completedTiles", JSON.stringify(this.completedTiles));
      
      for (let i = 1; i < 6; i++) {
        this.getProgress(i);
      }

    },

    isCompleted(t) {    
      if (this.completedTiles.includes(t)) {
        return true;
      }
      return false;
    },

    isActiveTab(dest) {
      return this.activeTab === dest;
    },

    voidPath() {
      this.path = 0;
      setCookie('path', 0);
    },

    setIntroQuestion(iq) {
      if (iq) {
        let previous_question = iq - 1;
        if (previous_question < 1)  { previous_question = 1; }

        if (this.getAnswer('intro-questionnaire-question' + previous_question)) {
         this.intro_question = iq;
        }
      } else {
        this.intro_question = this.intro_question + 1;
      }
    },

    previousIntroQuestion() {
      this.intro_question = this.intro_question - 1;
    },

    nextIntroQuestion() {
      let goto_question = this.intro_question + 1;
      if (this.getAnswer('intro-questionnaire-question' + this.intro_question)) {
        this.intro_question = goto_question;
      }
    },

    hideQuestionnaire() {
      this.showQuestionnaire = 0;
      setCookie('show-questionnaire', 0);
    },

    setPath(p, go = 1) {
      this.path = p;
      this.step = 1;

      setCookie('step', 1);
      setCookie('path', p);
    },

    setStep(s) {
      this.step = s;
      setCookie('step', s);
    },

    getClass(q, v) {
      if (this.getAnswer(q) == v) {
        return v + ' selected';
      }
      return v;
    },

    goToCamp(c, p) {
      this.activeTab = 'camp' + c;
      this.camp = c;
      this.path = p;
      this.introEnd = 1;

      setCookie('camp', c);
      setCookie('path', p);
      setCookie('activeTab', 'camp' + c);
      setCookie('introEnd', 1);

      //this.$refs.audiomap.pause();
      this.$refs.player.player.pause();
    },

    launch() {
      let self = this;
      self.activeTab = 'camp' + self.camp;
      self.introEnd = 1;

      self.camp = self.questionCamp;

      setCookie('introEnd', 1);
      setCookie('activeTab', 'camp' + self.camp);

      //this.$refs.audiomap.currentTime = 24;
      //this.$refs.audiomap.play();
      this.$refs.player.player.setCurrentTime(25);
      this.$refs.player.player.play();
      this.playing = 1;

      self.hideQuestionnaire(); 
      
      if (this.points < 11) {
        this.showTile('1.' + this.path + '.1');
      } else if (this.points < 16) {
        this.showTile('2.' + this.path + '.1');
        this.fromQuestionnaire = 1;
      } else if (this.points < 23) {
        this.showTile('3.' + this.path + '.1');
        this.fromQuestionnaire = 1;
      } else {
        this.showTile('4.' + this.path + '.1');
        this.fromQuestionnaire = 1;
      }

    },

    saveAnswer(key, value) {
      setCookie(key, value);
      if (key.match("-q-")) { return; }
      
      switch (key) {
        case 'intro-questionnaire-question1': 
          this.intro_answer1 = value;
          break;
        case 'intro-questionnaire-question2': 
          this.intro_answer2 = value;
          break;
        case 'intro-questionnaire-question3': 
          this.intro_answer3 = value;
          break;
        case 'intro-questionnaire-question4': 
          this.intro_answer4 = value;
          break;
        case 'intro-questionnaire-question6': 
          this.intro_answer6 = value;
          break;
        case 'intro-questionnaire-question7': 
          this.intro_answer7 = value;
          break;
        case 'intro-questionnaire-question8': 
          this.intro_answer8 = value;
          break;
      }

      this.savePoint();
    },

    savePoint() {
      let point = 0;
      switch (this.intro_answer1) {
        case 'gen1': point = point + 1; break;
        case 'gen2': point = point + 2; break;
        case 'gen3': point = point + 3; break;
        case 'gen4': point = point + 4; break;
      }

      switch (this.intro_answer2) {
        case 'values-not-radar': point = point + 1; break;
        case 'values-not-transmitted': point = point + 2; break;
        case 'values-mentioned-outdated': point = point + 3; break;
        case 'values-talked-about': point = point + 4; break;
        case 'values-deeply-engrained': point = point + 5; break;
      }
      
      switch (this.intro_answer3) {
        case 'selling': point = point + 1; break;
        case 'not-interested': point = point + 2; break;
        case 'no-letting-go': point = point + 3; break;
        case 'not-ready': point = point + 4; break;
      }  

      switch (this.intro_answer4) {
        case 'never': point = point + 1; break;
        case 'rarely': point = point + 2; break;
        case 'sometimes': point = point + 3; break;
        case 'often': point = point + 4; break;
        case 'always': point = point + 5; break;
      }

      let answer5 = getCookie('intro-questionnaire-question5');
      if (!answer5) { answer5 = "[]"; }
      answer5 = JSON.parse(answer5);
      let answer5_point = 0;
      for (let i = 0; i < answer5.length; i++) {
        answer5_point++;
      }

      switch (answer5_point) {
        case 1:
        case 2: 
          point = point + 1; break;
        
        case 3:
        case 4: 
          point = point + 2; break;

        case 5:
        case 6: 
          point = point + 3; break;

        case 7:
        case 8: 
          point = point + 4; break;
      }

      switch (this.intro_answer6) {
        case 'very-unprepared': point = point + 1; break;
        case 'unprepared': point = point + 2; break;
        case 'somewhat-prepared': point = point + 3; break;
        case 'prepared': point = point + 4; break;
        case 'very-prepared': point = point + 5; break;
      }
      
      this.points = point;
      //&& this.intro_answer8
      
    },

    saveAnswer5(key, value) {
      let answer5 = getCookie('intro-questionnaire-question5');
      if (!answer5) { answer5 = "[]"; }
      answer5 = JSON.parse(answer5);

      if (answer5.includes(value)) {
        answer5 = answer5.filter( (a) => a != value);
      } else {
        answer5.push(value);
      }

      setCookie("intro-questionnaire-question5", JSON.stringify(answer5));

      let answer5_str = '';
      for (let i = 0; i < answer5.length; i++) {
        answer5_str = answer5_str + ' ' + answer5[i];
      }
      
      this.intro_answer5 = answer5_str;

      this.savePoint();

    },

    getAnswer(key) {
      return getCookie(key);
    },

    goToIntro(ie = 1) {
      this.camp = 0;
      this.step = 0;
      this.tile = 0;
      this.path = 0;
      this.activeTab = "intro";
      
      setCookie('camp', 0);
      setCookie('step', 0);
      setCookie('path', 0);
      setCookie('tile', 0);
      setCookie('activeTab', 'intro');

      if (!ie) {
        this.introEnd = 0;
        setCookie('introEnd', 0);
        this.$refs.player.player.setCurrentTime(0);
        this.$refs.player.player.play();
        this.playing = 1;
      }
      
      //this.$refs.audiomap.currentTime = 0;
      //this.$refs.audiomap.play();


    },

    toggleCredit() {
      if (this.credits) {
        this.credits = 0;
      } else {
        this.credits = 1;
      }
    },

    vimeoOnReady(player) {
      this.playerReady = 1;
    },

    vimeoOnCuepoint(c) {
      //console.log(c);
    },

    showSurvey() {
      document.getElementById("survey").style.display = 'block';
    },

    hideSurvey() {
      document.getElementById("survey").style.display = 'none';
      this.credits = 0;
    },

    setIntroNav() {
      //this.$refs.audiomap.currentTime = 25;
      //this.$refs.audiomap.pause();
      this.$refs.player.player.setCurrentTime(25);
      this.$refs.player.player.pause();
      this.introEnd = 1;
      this.showQuestionnaire = 1;
      this.playing = 0;
      this.camp = 0;

      document.getElementById("background-video").classList.remove("animate-intro-started");
      document.getElementById("background-video").classList.remove("animate-intro-step2");
      document.getElementById("background-video").classList.remove("animate-intro");
      document.getElementById("background-video").classList.remove("animate-intro-camp1");
      document.getElementById("background-video").classList.remove("animate-intro-camp2");
      document.getElementById("background-video").classList.remove("animate-intro-camp3");
      document.getElementById("background-video").classList.remove("animate-intro-camp4");

      setCookie('introEnd', 1);
      setCookie('playing', 0);
    },

    handleTimeUpdate(time) {
      
      if (this.camp > 4) { 
        this.$refs.player.player.pause();
        return
      }

      if (this.$refs.player.getStatus() == "played") {
        this.playing = 1;
        this.authorizedPlay = 1;
      }

      if (this.introEnd == 0 && time > 25) {
        this.$refs.player.player.pause();
        this.introEnd = 1;
        this.playing = 0
        this.showQuestionnaire = 1;
        return
      }

      if (time > 0 && time < 25) {
        this.camp = 0;
        this.activeTab = 'intro';
        this.introEnd = 0;
      }

      if (time >= 88.5 && time < 89) {
        this.playing = 0;
        this.camp = 1;
        this.path = 1;
        this.camp11End = 1;
        setCookie('camp11End', 1);
        this.showContent = 1;
        this.$refs.player.player.pause();
        this.$refs.player.player.setCurrentTime(89);
        return
      }

      if (time >= 163.5 && time < 164) {
        this.playing = 0;
        this.camp = 1;
        this.path = 2;
        this.camp12End = 1;
        setCookie('camp12End', 1);
        this.showContent = 1;
        this.$refs.player.player.pause();
        this.$refs.player.player.setCurrentTime(164);
        return
      }

      if (time >= 249.5 && time < 250) {
        this.playing = 0;
        this.camp = 1;
        this.path = 3;
        this.camp13End = 1;
        setCookie('camp13End', 1);
        this.showContent = 1;
        this.$refs.player.player.pause();
        this.$refs.player.player.setCurrentTime(250);
        return
      }

      if (time >= 356.5 && time < 357) {
        this.playing = 0;
        this.camp = 2;
        this.path = 1;
        this.camp21End = 1;
        setCookie('camp21End', 1);
        this.showContent = 1;
        this.$refs.player.player.pause();
        this.$refs.player.player.setCurrentTime(357);
        return
      }

      if (time >= 440.5 && time < 441) {
        this.playing = 0;
        this.camp = 2;
        this.path = 2;
        this.camp22End = 1;
        setCookie('camp22End', 1);
        this.showContent = 1;
        this.$refs.player.player.pause();
        this.$refs.player.player.setCurrentTime(441);
        return
      }

      if (time >= 531.5 && time < 532) {
        this.playing = 0;
        this.camp = 2;
        this.path = 3;
        this.camp23End = 1;
        setCookie('camp23End', 1);
        this.showContent = 1;
        this.$refs.player.player.pause();
        this.$refs.player.player.setCurrentTime(532);
        return
      }

      if (time >= 672.5 && time < 673) {
        this.playing = 0;
        this.camp = 3;
        this.path = 1;
        this.camp31End = 1;
        setCookie('camp31End', 1);
        this.showContent = 1;
        this.$refs.player.player.pause();
        this.$refs.player.player.setCurrentTime(673);
        return
      }

      if (time >= 730.5 && time < 731) {
        this.playing = 0;
        this.camp = 3;
        this.path = 2;
        this.camp32End = 1;
        setCookie('camp32End', 1);
        this.showContent = 1;
        this.$refs.player.player.pause();
        this.$refs.player.player.setCurrentTime(731);
        return
      }

      if (time >= 791.5 && time < 792) {
        this.playing = 0;
        this.camp = 3;
        this.path = 3;
        this.camp33End = 1;
        setCookie('camp33End', 1);
        this.showContent = 1;
        this.$refs.player.player.pause();
        this.$refs.player.player.setCurrentTime(792);
        return
      }

      if (time >= 910.5 && time < 911) {
        this.playing = 0;
        this.camp = 4;
        this.path = 1;
        this.camp41End = 1;
        setCookie('camp41End', 1);
        this.showContent = 1;
        this.$refs.player.player.pause();
        this.$refs.player.player.setCurrentTime(911);
        return
      }

      if (time >= 955.5 && time < 956) {
        this.playing = 0;
        this.camp = 4;
        this.path = 2;
        this.camp42End = 1;
        setCookie('camp42End', 1);
        this.showContent = 1;
        this.$refs.player.player.pause();
        this.$refs.player.player.setCurrentTime(956);
        return
      }

      if (time >= 1070 && time < 1071) {
        this.playing = 0;
        this.camp = 4;
        this.path = 3;
        this.camp43End = 1;
        setCookie('camp43End', 1);
        this.showContent = 1;
        this.$refs.player.player.pause();
        return
      }


    },


    getAnchor() {
      let currentUrl = document.URL;
      let urlParts = currentUrl.split('#');

      if (urlParts.length > 1) {
        let hash = urlParts[1].split("-");
        this.camp = hash[0];
        this.path = hash[1];
        this.step = hash[2];
        this.tile = hash[3];
      }
    }

  }
}
</script>

<style scoped>
 
</style>